import { AustralianAddress } from './';

export class Person {

  private _email: string;
  private _profileimg: string;
  private _displayName: string;
  private _firstName: string;
  private _lastName: string;
  private _phoneno: string;
  private _address: AustralianAddress;
  private _enabled: boolean;
  private _createAt: Date;
  private _createLocation: string;
  private _updateLocation: string;
  private _updatedAt: Date;

  public getEmail(): string {
    return this._email;
  }

  public setEmail(value: string) {
    this._email = value;
  }

  public getProfileimg(): string {
    return this._profileimg;
  }

  public setProfileimg(value: string) {
    this._profileimg = value;
  }

  public getDisplayName(): string {
    return this._displayName;
  }

  public setDisplayName(value: string) {
    this._displayName = value;
  }

  public getFirstName(): string {
    return this._firstName;
  }

  public setFirstName(value: string) {
    this._firstName = value;
  }

  public getLastName(): string {
    return this._lastName;
  }

  public setLastName(value: string) {
    this._lastName = value;
  }

  public getPhoneno(): string {
    return this._phoneno;
  }

  public setPhoneno(value: string) {
    this._phoneno = value;
  }

  public getAddress(): AustralianAddress {
    return this._address;
  }

  public getEnabledStatus(): boolean {
    return this._enabled;
  }

  public getCreateAtTime(): Date {
    return this._createAt;
  }

  public getCreateLocation(): string {
    return this._createLocation;
  }

  public getUpdateLocation(): string {
    return this._updateLocation;
  }

  public setUpdateLocation(value: string) {
    this._updateLocation = value;
  }

  public getUpdatedAtTime(): Date {
    return this._updatedAt;
  }

  public setUpdatedAtTime(value: Date) {
    this._updatedAt = value;
  }

  constructor(email: string, profileimg: string, displayName: string, firstName: string,
              lastName: string, phoneno: string, address?: AustralianAddress) {
    this._email = email;
    this._profileimg = profileimg;
    this._displayName = displayName;
    this._firstName = firstName;
    this._lastName = lastName;
    this._phoneno = phoneno;
    this._address = address;
    this._enabled = true;
    this._createLocation = 'TODO';
  }

  public toString(): string {

    if (this._address == null) {

      return 'Email: ' + this._email
        + ' Display Name: ' + this._displayName
        + ' First Name: ' + this._firstName
        + ' Last Name: ' + this._lastName
        + ' Phone no: ' + this._phoneno
        + ' Enabled?: ' + this._enabled;
    } else {

      return 'Email: ' + this._email
        + ' Display Name: ' + this._displayName
        + ' First Name: ' + this._firstName
        + ' Last Name: ' + this._lastName
        + ' Phone no: ' + this._phoneno
        + ' FakeAddress: ' + this._address.toString()
        + ' Enabled?: ' + this._enabled;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/core/person.ts